<app-title-section></app-title-section>

<div class="card p-1"  style="margin-left: 15px; margin-right: 15px; min-height:100vh;">

    <ul class="nav nav-tabs m-0 " style=" border-bottom: 1px solid #eee;">
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/achat/facture-fournisseur/tous']" [class.active]="currentStatus === 'tous'" (click)="filterByStatus('tous')">
                    Tous <app-tab-count [count]="getStatusCount('Tous')"></app-tab-count>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/achat/facture-fournisseur/brouillon']" [class.active]="currentStatus === 'brouillon'" (click)="filterByStatus('brouillon')">
                    Brouillon <app-tab-count [count]="getStatusCount('Brouillon')"></app-tab-count>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/achat/facture-fournisseur/paye']" [class.active]="currentStatus === 'paye'" (click)="filterByStatus('paye')">
                    Payé <app-tab-count [count]="getStatusCount('Payé')"></app-tab-count>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/achat/facture-fournisseur/part-paye']" [class.active]="currentStatus === 'partPaye'" (click)="filterByStatus('partPaye')">
                    Partiellement payé <app-tab-count [count]="getStatusCount('Partiellement payé')"></app-tab-count>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/achat/facture-fournisseur/non_payé']" [class.active]="currentStatus === 'non_payé'" (click)="filterByStatus('non_payé')">
                    Non Payé <app-tab-count [count]="getStatusCount('Non payé')"></app-tab-count>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/achat/facture-fournisseur/annule']" [class.active]="currentStatus === 'annule'" (click)="filterByStatus('annule')">
                    Annulé <app-tab-count [count]="getStatusCount('Annulé')"></app-tab-count>
                </a>
            </li>

        </ul>
        <div class="container-fluid" style="padding: 0; width: 100%; max-width: 100%;">
            <router-outlet></router-outlet>
        </div>
    </div>
